var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"org-link-container"},[_c('a',{attrs:{"href":_vm.destination}},[_vm._v("組織アカウント（ "+_vm._s(_vm.orgDomain)+" ）にアクセスする")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }